<template>
  <div>
    <button
      class="text-light btn btn-link text-decoration-none"
      @click="supportOffcanvas.show()"
    >
      <i class="bi bi-patch-question me-2"></i>Support
    </button>
    <div
      class="offcanvas offcanvas-start"
      tabindex="-1"
      ref="supportOffcanvas"
      aria-labelledby="offcanvasSupportLabel"
    >
      <div class="offcanvas-header bg-light border-bottom">
        <h2 class="offcanvas-title" id="offcanvasSupportLabel">
          <i class="bi bi-patch-question me-2"></i>Technical Support
        </h2>
        <button
          data-cy="closeModalButton"
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body">
        <div class="px-3">
          <CustomAlert
            >We're sorry that you've encountered technical difficulty. Please
            describe in detail what you have encountered so we can verify and
            reproduce the error. The support team will get back to you within
            one business day.</CustomAlert
          >
          <SupportForm @submitted="closeModal" data-cy="supportModal" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Offcanvas } from "bootstrap";
import SupportForm from "@/components/core/SupportForm.vue";
import CustomAlert from "@/components/ui/CustomAlert.vue";

export default {
  name: "OffcanvasSupport",
  components: {
    SupportForm,
    CustomAlert
  },
  data() {
    return {
      supportOffcanvas: null
    };
  },
  methods: {
    closeModal() {
      this.supportOffcanvas.hide();
    }
  },
  mounted() {
    this.supportOffcanvas = new Offcanvas(this.$refs.supportOffcanvas);
  }
};
</script>

<style scoped>
.offcanvas {
  width: 50rem !important;
}
</style>
